<template >
    <div class="container bg-light text-bat" ref="targetElement">
        <div class="row align-items-center justify-content-between mt-3">
            <div class="col-auto">
                <h5 class="text-title-bat" style="margin-bottom: 0;">{{ (client_segment === 20 || client_segment === 19) && !isChampion ? 'Conoce tu avance':'Gestión del equipo' }}</h5>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6">
                <div class="d-block d-lg-none d-xl-none">
                    <div class="bg-white shadow-lg fixed-top p-2 m-2 text-bat rounded-4" v-show="showDiv">
                        <div class="row d-flex align-items-center justify-content-center">
                            <div class="col-2 d-flex align-items-center justify-content-center">
                                <img src="/img-version2/icons/staff/info-staff.svg" alt="">
                            </div>
                            <div class="col-10">
                                <p class="fw-bold mb-0 text-break fs-7">Recuerda que tu % de rotación solo se actualiza con la información que nos proporcione el punto de venta.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-none d-lg-block d-xl-block" >
                    <div class="row mx-auto" v-if="showDiv">
                        <div class="bg-white shadow-lg p-2 m-2 m-md-0 my-md-2 text-bat rounded-4">
                            <div class="row d-flex align-items-center justify-content-center">
                                <div class="col-2 d-flex align-items-center justify-content-end">
                                    <img src="/img-version2/icons/staff/info-staff.svg" alt="">
                                </div>
                                <div class="col-8">
                                    <p class="fw-bold mb-0 text-break fs-7 text-center">Recuerda que tu % de rotación solo se actualiza con la información que nos proporcione el punto de venta.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3 mb-5" >
            <!--            <dropdowns-staff v-if="(client_segment === 20 || client_segment === 19) && isChampion" :client_segment="client_segment" :is_champion="isChampion" ></dropdowns-staff>-->

            <div :class="{
                'order-0' : !isChampion,
                // 'order-1' : isChampion,
                'order-md-0' : !isChampion,
                // 'order-md-1' : isChampion,
            }" class="col-12 col-md-12 col-lg-6 col-xl-6 order-lg-0 order-xl-0">
                <a v-if="(selected_pdv && selected_pdv.id)"
                   :href="(client_segment === 20 || client_segment === 19) && !isChampion
                    ? `/pdv-progress-user` : `/get-pdv-details/${selected_pdv.id}`" class="text-decoration-none">
                    <div class="progress-team-block d-flex align-items-center shadow-sm">
                        <div class="circle-team-wrapper me-3">
                            <el-progress
                                type="circle"
                                :color="'#285496'"
                                :percentage="percentage"
                                :width="64"
                                :stroke-width="6"
                            ></el-progress>
                        </div>
                        <div class="d-flex align-items-center justify-content-between flex-grow-1">
                            <span class="progress-team-text ">
                                {{ (client_segment === 20 || client_segment === 19) && !isChampion? 'Consulta el progreso de tus actividades': 'Conoce el avance de tu equipo' }}
                            </span>
                            <span class="chevron-team-icon ms-3">
                                <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 2L10 10L2 18" stroke="#464646" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <div v-if="pageIsLoaded">
            <div v-if="canShowClientMetrics()">
                <div class="row align-items-center">
                    <div class="col-12 col-md-6 mb-2 mb-md-0 d-flex flex-column justify-content-center">
                        <h5 class="text-title-bat">{{ metricsTitle }}</h5>
                        <p class="fs-6">Se actualiza según la información del punto de venta.</p>
                    </div>

                    <div class="col-12 col-md-6 d-flex align-items-center justify-content-between justify-content-md-end flex-wrap flex-md-nowrap mb-3">
                        <span class="text-bat fs-6 me-2 white-space-nowrap">Filtra por mes:</span>
                        <div class="month-filter-staff" style="min-width: 0;">
                            <form>
                                <select v-model="selected_month" @change="getCurrentData()">
                                    <option v-for="month in available_client_months_staff" :value="month.month">
                                        {{ getMonthText(month.month) }}
                                    </option>
                                </select>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 col-lg-4 mb-3">
                        <div v-if="metric_available_types && metric_available_types.length == 2 && [8, 21, 23].includes(client_segment)" class="tab-container-staff shadow-sm">
                            <button @click="changeSelectedTab(0)" class="tab-button" :class="selected_tab == 0 ? 'active' : ''">Rotación</button>
                            <button @click="changeSelectedTab(1)" class="tab-button" :class="selected_tab == 1 ? 'active' : ''">Compra</button>
                        </div>
                    </div>

                    <div v-if="metric_available_types && shouldShowIncentives() && [8, 21, 23].includes(client_segment)" class="col-md-12 col-lg-8 mb-2">
                        <div class="card-incentives">
                            <div class="header">
                                <h2>Incentivos disponibles</h2>
                                <p>Cumple todas las variables asociadas a un incentivo para obtener más puntos</p>
                            </div>

                            <div v-if="selected_tab == 0" class="incentives">
                                <div v-for="(incentive, index) in incentives_by_type.ROTACION" :key="index" class="inner-card">
                                    <div v-if="incentive && incentive.points != null" :class="index == 0 ? 'purple' : 'cyan'">
                                        <div class="card-header">
                                            <h5 class="card-title">{{ capitalizeFirstLetter(incentive.name) }}</h5>
                                        </div>
                                        <div class="card-body">
                                            <img v-if="index == 0" class="box-icon" src="/img/icons/purple-objective.svg" alt="incentivo" />
                                            <img v-else class="box-icon" src="/img/icons/cyan-objective.svg" alt="incentivo" />

                                            <div class="box-points">
                                                <div class="points">{{ incentive.points }}</div>
                                                <div class="label">Puntos</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="selected_tab == 1" class="incentives">
                                <div v-for="(incentive, index) in incentives_by_type.COMPRA" :key="index" class="inner-card">
                                    <div v-if="incentive && incentive.points != null" :class="index == 0 ? 'orange' : 'green'">
                                        <div class="card-header">
                                            <h5 class="card-title">{{ capitalizeFirstLetter(incentive.name) }}</h5>
                                        </div>
                                        <div class="card-body">
                                            <img v-if="index == 0" class="box-icon" src="/img/icons/orange-objective.svg" alt="incentivo" />
                                            <img v-else class="box-icon" src="/img/icons/green-objective.svg" alt="incentivo" />

                                            <div class="box-points">
                                                <div class="points">{{ incentive.points }}</div>
                                                <div class="label">Puntos</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="alert-box-incentives mt-3">
                            <img class="box-icon" src="/img/icons/info-circle.svg" alt="info-circle" />
                            <div>
                                <b>Ten en cuenta:</b> Los puntos mostrados en cada incentivo ya incluyen los de sus variables.
                                Es decir, si completas todas las variables, recibirás el total indicado del incentivo
                                <b>(no se suman puntos extra por cada variable)</b>.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="btn-container-top mt-3">
                    <a @click="changeDisplayMode()" class="d-flex btn btn-detail-staff">
                        <img v-if="display_mode == 0" class="img-menu-fixed" src="/img/icons/add.svg" alt="Vista Detallada">
                        <img v-else class="img-menu-fixed" src="/img/icons/minus.svg" alt="Vista menos detalles">

                        <span v-if="display_mode == 0"> Ver vista detallada</span>
                        <span v-else> Ver menos detalles</span>
                    </a>
                </div>

                <div v-if="display_mode === 0" class="staff-objectives-container mt-4">
                    <div class="staff-wrapper mb-3">
                        <div @click="changeDisplayMode(objective.incentive)" v-for="(objective, index) in metrics_by_type" :key="index" class="card-staff-objetives shadow-sm">
                            <div class="circle-wrapper-mobile">
                                <div v-if="objective && objective.incentive && selected_tab == 0 && [8, 21, 23].includes(client_segment)" class="top-left-incentive-icon">
                                    <img v-if="getIncentiveForGoal(objective.incentive) == 0" class="box-icon" src="/img/icons/purple-objective.svg" alt="incentivo" />
                                    <img v-else class="box-icon" src="/img/icons/cyan-objective.svg" alt="incentivo" />
                                </div>
                                <div v-else-if="objective && objective.incentive && selected_tab == 1 && [8, 21, 23].includes(client_segment)" class="top-left-incentive-icon">
                                    <img v-if="getIncentiveForGoal(objective.incentive) == 0" class="box-icon" src="/img/icons/orange-objective.svg" alt="incentivo" />
                                    <img v-else class="box-icon" src="/img/icons/green-objective.svg" alt="incentivo" />
                                </div>

                                <div v-if="objective && objective.variable_points_to_win && isLinked" class="top-right-points-box">
                                    <span><strong>{{ Math.round(objective.variable_points_to_win) }}</strong> Puntos</span>
                                </div>

                                <el-progress
                                    type="circle"
                                    class="circle"
                                    :percentage="(Number(objective.advance) * 100) > 100 ? 100 : Math.floor(Number(objective.advance) * 100)"
                                    :width="48"
                                    :stroke-width="5"
                                    :color="customColorMethods"
                                ></el-progress>
                            </div>

                            <div class="circle-wrapper-desktop">
                                <div v-if="objective && objective.incentive && selected_tab == 0 && [8, 21, 23].includes(client_segment)" class="top-left-incentive-icon">
                                    <img v-if="getIncentiveForGoal(objective.incentive) == 0" class="box-icon" src="/img/icons/purple-objective.svg" alt="incentivo" />
                                    <img v-else class="box-icon" src="/img/icons/cyan-objective.svg" alt="incentivo" />
                                </div>
                                <div v-else-if="objective && objective.incentive && selected_tab == 1 && [8, 21, 23].includes(client_segment)" class="top-left-incentive-icon">
                                    <img v-if="getIncentiveForGoal(objective.incentive) == 0" class="box-icon" src="/img/icons/orange-objective.svg" alt="incentivo" />
                                    <img v-else class="box-icon" src="/img/icons/green-objective.svg" alt="incentivo" />
                                </div>

                                <div v-if="objective && objective.variable_points_to_win && isLinked" class="top-right-points-box">
                                    <span><strong>{{ Math.round(objective.variable_points_to_win) }}</strong> Puntos</span>
                                </div>

                                <el-progress
                                    type="circle"
                                    class="circle"
                                    :percentage="(Number(objective.advance) * 100) > 100 ? 100 : Math.floor(Number(objective.advance) * 100)"
                                    :width="64"
                                    :stroke-width="6"
                                    :color="customColorMethods"
                                ></el-progress>
                            </div>

                            <div class="card-text-objetives">
                                {{ objective.variable }}
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else class="row mt-3">
                    <div v-for="(objective, index) in metrics_by_type" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                        <div class="card-var position-relative" style="height: 83px; margin-bottom: 0;">
                            <div class="wrapper-var" style="grid-template-columns: 40% 30% 30% !important;">
                                <div class="box box1">
                                    <div class="box-content">
                                        <p class="variable-name">{{ objective.variable }}</p>
                                        <p class="valor">{{ objective.unit_measure }}</p>

                                        <el-progress class="variable-value" :percentage="(Number(objective.advance) * 100) > 100 ? 100 : (Number(objective.advance) * 100)" :show-text="false" :color="customColorMethods"></el-progress>
                                        <p class="text-advance">({{ Math.round(objective.advance * 10000) / 100 }}%)</p>
                                    </div>
                                </div>
                                <div class="box box2">
                                    <div class="box-content">
                                        <p class="rotulo">Objetivo</p>
                                        <p class="valor">{{ numberFormat(Math.round(objective.goal)) }}</p>
                                    </div>
                                </div>
                                <div class="box box3">
                                    <div class="box-content">
                                        <p class="rotulo">Avance</p>
                                        <p class="valor">{{ numberFormat(Math.round(objective.real)) }}</p>
                                    </div>
                                </div>
                                <div class="box box4 position-relative">
                                    <div class="box-content">
                                        <p class="rotulo">Restante</p>
                                        <p class="valor">{{ numberFormat(Math.round(objective.goal - objective.real)) < 0 ? 0 : numberFormat(Math.round(objective.goal - objective.real)) }}</p>
                                    </div>
                                    <div v-if="objective && objective.incentive && selected_tab == 0 && [8, 21, 23].includes(client_segment)" class="top-right-incentive-icon">
                                        <img v-if="getIncentiveForGoal(objective.incentive) == 0" class="box-icon" src="/img/icons/purple-objective.svg" alt="incentivo" />
                                        <img v-else class="box-icon" src="/img/icons/cyan-objective.svg" alt="incentivo" />
                                    </div>
                                    <div v-else-if="objective && objective.incentive && selected_tab == 1 && [8, 21, 23].includes(client_segment)" class="top-right-incentive-icon">
                                        <img v-if="getIncentiveForGoal(objective.incentive) == 0" class="box-icon" src="/img/icons/orange-objective.svg" alt="incentivo" />
                                        <img v-else class="box-icon" src="/img/icons/green-objective.svg" alt="incentivo" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="btn-container-bottom">
                    <a @click="changeDisplayMode()" class="d-flex btn btn-detail-staff">
                        <img v-if="display_mode == 0" class="img-menu-fixed" src="/img/icons/add.svg" alt="Vista Detallada">
                        <img v-else class="img-menu-fixed" src="/img/icons/minus.svg" alt="Vista menos detalles">

                        <span v-if="display_mode == 0"> Ver vista detallada</span>
                        <span v-else> Ver menos detalles</span>
                    </a>
                </div>
            </div>
            <div v-else>
                <!-- <no-data-staff
                    :title="'Sin objetivos pendientes'"
                    :description="'Aprovecha este momento libre.'"
                ></no-data-staff> -->

                <no-data-staff v-if="initial_loading === false"
                    :title="'Aún no tienes objetivos cargados para mostrar'"
                    :description="'Comunícate con tu Gerente para actualizar la información.'"
                ></no-data-staff>
            </div>
        </div>
    </div>
</template>

<script>

import { EventBus } from './../../app';

export default {
    props: {
        identification: {
            default: null,
        },
        month: {
            default: null,
        },
        year: {
            default: null,
        },
        client_segment: {
            default: 3,
        },
        url_media: {
            default: '',
        },
    },
    data() {
        return {
            initial_loading: true,
            loading: 0,
            selected_month: 0,
            selected_year: 0,
            available_client_months_staff: [],
            client_metric_accomplishments_staff: [],
            incentives_staff: [],
            staff_goal_types: [],
            metrics_by_type: [],
            incentives_by_type: [],
            status_display: false,
            progressWidth: 40,

            selected_pdv: null,
            selected_tab: 0, // 0: Rotación, 1: Compra
            display_mode: 0, // 0: Simplificada, 1: Detallada
            accomplishment: 0,
            metric_available_types: [],
            percentage: 0,
            isParentVisible: false,

            pageIsLoaded: false,
            showDiv: false,
            pdvs: [],
            selectedPdv: null,
            isChampion: false,
            isLinked: false,
        };
    },
    computed: {
        metricsTitle() {
            const hasMetrics = this.metric_available_types?.length > 0;
            const isAdminSegment = [8, 21, 23].includes(this.client_segment);

            if (!hasMetrics) return 'Tus objetivos';

            const hasBothTypes = this.metric_available_types.length === 2;
            const isRotationOnly = this.metric_available_types.length === 1 &&
                                this.metric_available_types[0] === 'ROTACION';
            const isPurchaseOnly = this.metric_available_types.length === 1 &&
                                this.metric_available_types[0] === 'COMPRA';

            if (hasBothTypes) {
                return isAdminSegment ? 'Tus objetivos' : 'Tus objetivos de rotación';
            }

            if (isRotationOnly) {
                return 'Tus objetivos de rotación';
            }

            if (isPurchaseOnly) {
                return 'Tus objetivos de compra';
            }

            return 'Tus objetivos';
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        if (this.month && this.year) {
            this.selected_month = this.month;
            this.selected_year = this.year;
        }
        this.validateIsChampion();
        this.validateLinkingDate();
        this.getStatusDisplayStaff();
        this.getStaffMonthsData()

        EventBus.$on('change-select-pdv', function (select_pdv) {
            this.initial_loading = true;
            this.selected_pdv = { id: select_pdv.select_pdv }
            this.getStaffMonthsData()
            this.percentageStaff();
        }.bind(this));

        this.getStaffGoalTypes();
        this.getStaffIncentives();
        this.getMetricsByType();
        if (document.readyState === 'complete') {
            this.pageIsLoaded = true;
        } else {
            window.addEventListener('load', () => {
                this.pageIsLoaded = true;
            });
        }
    },
    methods: {
        canShowClientMetrics() {
            if (this.client_metric_accomplishments_staff.length === 0) return false;

            if (this.metric_available_types?.length === 1 && this.metric_available_types[0] === 'COMPRA') {
                return [8, 21, 23].includes(this.client_segment);
            }
            return true;
        },
        shouldShowIncentives() {
            return (
                (this.selected_tab === 0 &&
                    this.incentives_by_type.hasOwnProperty("ROTACION") &&
                    Array.isArray(this.incentives_by_type.ROTACION) &&
                    this.incentives_by_type.ROTACION.some(item => item.points != null)) ||

                (this.selected_tab === 1 &&
                    this.incentives_by_type.hasOwnProperty("COMPRA") &&
                    Array.isArray(this.incentives_by_type.COMPRA) &&
                    this.incentives_by_type.COMPRA.some(item => item.points != null))
            );
        },
        getMetricTypes() {
            const validTypes = new Set(['ROTACION', 'COMPRA']);
            const foundTypes = new Set();

            for (const item of this.client_metric_accomplishments_staff) {
                if (validTypes.has(item.type)) {
                    foundTypes.add(item.type);
                }
            }

            this.metric_available_types = [...foundTypes];

            if (this.metric_available_types.length === 0) {
                this.selected_tab = -1;
            } else if (this.metric_available_types.length === 1) {
                this.selected_tab = this.metric_available_types[0] === 'ROTACION' ? 0 : 1;
            } else {
                this.selected_tab = 0;
            }

            this.getMetricsByType();
        },
        changeSelectedTab(index) {
            this.selected_tab = index;
            this.getMetricsByType();
        },
        changeDisplayMode() {
            this.display_mode = this.display_mode === 0 ? 1 : 0;
            this.getMetricsByType();
        },
        getMetricsByType() {
            this.metrics_by_type = this.client_metric_accomplishments_staff.filter((item) => {
                if (this.selected_tab === 0) {
                    return item.type === 'ROTACION';
                } else if (this.selected_tab === 1) {
                    return item.type === 'COMPRA';
                }
            });

            this.getIncentivesByTypeFromMetrics();
        },
        getIncentivesByTypeFromMetrics() {
            const incentives_by_type = {};

            this.metrics_by_type.forEach((metric) => {
                const { incentive, incentive_value, type } = metric;

                // Validar que incentive y incentive_value no sean nulos, undefined o vacíos
                if (!incentive || incentive_value === null || incentive_value === undefined || incentive_value === '') {
                    return; // Saltar esta iteración
                }

                const type_name = type.toUpperCase();

                if (!incentives_by_type[type_name]) {
                    incentives_by_type[type_name] = [];
                }

                const exists = incentives_by_type[type_name].some(
                    (item) => item.name === incentive
                );

                if (!exists) {
                    incentives_by_type[type_name].push({
                        name: incentive,
                        points: incentive_value,
                        type_name: type_name
                    });
                }
            });

            this.incentives_by_type = incentives_by_type;
        },
        getIncentiveForGoal(goal_type) {
            let selected_type = null;

            if (this.selected_tab === 0) {
                selected_type = 'ROTACION';
            } else if (this.selected_tab === 1) {
                selected_type = 'COMPRA';
            }

            let index = -1;

            if (selected_type === 'ROTACION' && this.incentives_by_type != [] && this.incentives_by_type.ROTACION) {
                index = this.incentives_by_type.ROTACION.findIndex(
                    incentive => incentive.name.toUpperCase() === goal_type.toUpperCase()
                );
            } else if (selected_type === 'COMPRA' && this.incentives_by_type != [] && this.incentives_by_type.COMPRA) {
                index = this.incentives_by_type.COMPRA.findIndex(
                    incentive => incentive.name.toUpperCase() === goal_type.toUpperCase()
                );
            }

            return index;
        },
        getCurrentData() {
            if (!this.selected_pdv || !this.selected_pdv.id) {
                return;
            }

            this.loading++;
            axios.get(`/get-home-from-api-result?identification=${this.identification}&pdv=${this.selected_pdv.id}&month=${this.selected_month}&year=${this.selected_year}`)
                .then(({ data }) => {
                    this.client_metric_accomplishments_staff = data.client_metric_accomplishments_staff;
                    this.loading--;
                    this.initial_loading = false;
                    this.getMetricsByType();
                    this.getMetricTypes();
                });
        },
        getStaffMonthsData(){
            axios.get(`/get-data-months-staff`).then(({ data }) => {
                this.available_client_months_staff = data.available_client_months_staff === null ? [] : data.available_client_months_staff;
                this.selected_month = this.available_client_months_staff.length > 0 ? this.available_client_months_staff[0].month : 0;
                this.getCurrentData()
            })
                .catch(error => {
                    console.error("Error al obtener los meses con objetivos", error);
                });
        },
        getStaffGoalTypes() {
            axios.get(`/get-staff-goal-types`)
                .then(({ data }) => {
                    this.staff_goal_types = data.staff_goal_types;
                })
                .catch(error => {
                    console.error("Error al obtener los incentivos", error);
                });
        },
        getStaffIncentives() {
            axios.get(`/get-staff-incentives`)
                .then(({ data }) => {
                    this.incentives_staff = data.incentives_staff;
                })
                .catch(error => {
                    console.error("Error al obtener los incentivos", error);
                });
        },
        // getActivePdvs() {
        //     axios.get('/get-active-pdvs')
        //         .then(({ data }) => {
        //             this.pdvs = data.pdvs;
        //
        //             if (this.pdvs.length > 0) {
        //                 this.selected_pdv = data.selected_pdv !== null ? data.selected_pdv : this.pdvs[0];
        //                 this.available_client_months_staff = data.available_client_months_staff;
        //             } else {
        //                 this.selected_pdv = null;
        //             }
        //         })
        //         .catch(error => {
        //             console.error("Error al obtener los PDVs activos", error);
        //         });
        // },
        updateSelectedPdvClient() {
            axios
                .post(`/update-selected-pdv-client`, {
                    pdv_id: this.selected_pdv,
                })
                .then(({ data }) => {
                    this.pdvs = data.pdvs;

                    if (this.pdvs.length > 0) {
                        this.selectedPdv = this.pdvs[0].id;
                    }
                })
                .catch(error => {
                    console.error("Error al obtener los PDVs activos", error);
                });
        },

        changeSelectedPDV(pdvId) {
            this.loading++;

            axios.post('/change-selected-pdv', { pdv_id: pdvId })
                .then(response => {
                })
                .catch(error => {
                    console.error('Error al cambiar el PDV seleccionado:', error);
                    this.loading--;
                });
        },

        handleSelectChange() {
            if (this.selectedPdv) {
                this.changeSelectedPDV(this.selectedPdv);

                EventBus.$emit('change-select-pdv', { select_pdv: this.selectedPdv });
            }
        },

        formatName(name) {
            let nameParts = name.split(' ').map(part => {
                return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
            });

            return nameParts.join(' ');
        },
        getStatusDisplayStaff() {
            axios.get(`/status-display-staff/${this.client_segment}`)
                .then(response => {
                    this.status_display = response.data.status_display;
                })
                .catch(e => {
                    //
                })
        },
        getMonthText(month) {
            switch (month) {
                case 1:
                    return "Enero";
                    break;
                case 2:
                    return "Febrero";
                    break;
                case 3:
                    return "Marzo";
                    break;
                case 4:
                    return "Abril";
                    break;
                case 5:
                    return "Mayo";
                    break;
                case 6:
                    return "Junio";
                    break;
                case 7:
                    return "Julio";
                    break;
                case 8:
                    return "Agosto";
                    break;
                case 9:
                    return "Septiembre";
                    break;
                case 10:
                    return "Octubre";
                    break;
                case 11:
                    return "Noviembre";
                    break;
                case 12:
                    return "Diciembre";
                    break;
                default:
                    break;
            }
        },
        customColorMethods(percentage) {
            if (percentage >= 100) {
                return 'green';
            } else if (percentage >= 91 && percentage < 100) {
                return 'orange';
            } else {
                return 'red';
            }
        },
        formatUnitMeasure(text){
            return text[0].toUpperCase() + text.substring(1).toLowerCase();
        },
        percentageStaff(){
            axios
                .get(`get-percentage-staff/${this.selected_pdv.id}`)
                .then(({ data }) => {
                    this.percentage = data.percentage;
                })
                .catch(error => {
                    console.error('Error al obtener el porcentaje:', error);
                    this.percentage = 0;
                });
        },
        progressBarWidth() {
            return (this.progressPercentage / this.points) * 100;
        },
        getConditionalClass(objetive) {
            const advancePercentage = objetive;
            return {
                green: advancePercentage >= 100,
                yellow: advancePercentage >= 50 && advancePercentage < 100,
                red: advancePercentage < 50,
            };
        },
        numberFormat(number) {
            const exp = /(\d)(?=(\d{3})+(?!\d))/g
            const rep = '$1,'
            let arr = number.toString().split('.')
            arr[0] = arr[0].replace(exp,rep)
            return arr[1] ? arr.join('.'): arr[0]
        },
        handleScroll() {
            const offset = 100;
            const targetElementPosition = this.$refs.targetElement.offsetTop - offset;
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.showDiv = scrollPosition >= targetElementPosition;
        },
        capitalizeFirstLetter(text) {
            if (!text) return '';
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        },
        validateIsChampion(){
            axios
                .get(`validate-is-pdv-champion`)
                .then(({ data }) => {
                    this.isChampion = data.is_champion;
                })
                .catch(error => {
                    console.error('Error al obtener el porcentaje:', error);
                    this.isChampion = false;
                });
        },
        validateLinkingDate(){
            axios
                .get(`/validate-linking-date`)
                .then(({ data }) => {
                    this.isLinked = data.is_linked;
                })
                .catch(error => {
                    console.error('Error al obtener el estado de vinculación al punto de venta:', error);
                    this.isLinked = false;
                });
        },
    },
};
</script>
